ux-iws-search-tag-group {
    display: block;
    margin-bottom: 10px;
}

.ux-iws-search-tag-group {
    &__selection {
        display: none;

        .ux-iws-search-tag-group--active & {
            display: block;
        }
    }

    &__tags {
        display: block;
        font-size: 0;
        opacity: 0;
        overflow: hidden;
        height: 0;

        ux-iws-search-tag {
            margin: 0 10px 10px 0;
        }
    }

    &--expanded &__selection {
        margin-bottom: 0;
    }

    &--expanded &__tags {
        margin-bottom: 30px;
        height: auto;
        opacity: 1;
        transition: opacity 0.2s ease-in-out;
    }

    &--collapsed &__tags {
        display: none;
    }

    &:last-of-type &__tags {
        margin-bottom: 0;
    }

    &:not(:first-of-type):not(.ux-iws-search-tag-group--active) &__tags {
        margin-top: 30px;
    }
}
